
define('ldsh!modules/form_editor/templates/editor_check_radio', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h4 data-i18n="formEditor.elementsTitle">Elementos</h4>\n<div class="js-items"></div>';

}
return __p
};});

